import CheckBooking from 'modules/check-booking';

export default CheckBooking;
